/**
 * Use Link Document Hook
 *
 * Wraps the linkDocumentToChecklistItem mutation using useApiMutation
 * for consistent error handling.
 */

import { useTranslation } from "react-i18next";
import { api } from "convex/_generated/api";
import { useApiMutation } from "@/packages/features-shared";
import type { Id } from "@/packages/types";

export function useLinkDocument() {
  const { t } = useTranslation("audits");
  const mutation = useApiMutation(
    api.checklist_mutations.linkDocumentToChecklistItem,
    {
      name: "link-document-to-checklist-item",
      successMessage: t("documents.successLink"),
    },
  );

  return (args: {
    documentId: Id<"documents">;
    checklistItemId: Id<"checklistItems">;
  }) => mutation.mutateAsync(args);
}
